// Константы сайта отдельным модулем, чтобы не было цикла: реестр страниц
// (pages.js) строит разметку через jsonLd.js, а тому нужен адрес сайта. Если бы
// он брал его из pages.js, получилось бы кольцо — в CommonJS оно не падает, а
// тихо отдаёт пустой объект, и в ссылках вместо домена оказался бы undefined.
const SITE = 'https://rbxpier.me'

// Растр, а не svg: соцсети и Google не рендерят svg в превью и в разметке.
// 1200×630 без альфы: иконка манифеста квадратная и прозрачная, из-за неё
// карточка держалась на summary, а фон соцсети заливали сами.
// jpg, а не png: баннер градиентный, палитра на 256 цветов полосит.
const DEFAULT_OG_IMAGE = `${SITE}/og-cover.jpg`
const OG_IMAGE_WIDTH = '1200'
const OG_IMAGE_HEIGHT = '630'
const OG_IMAGE_ALT = 'RBXPier — безопасная и быстрая покупка робуксов Roblox'

// Логотип организации в разметке — не баннер: Google ждёт здесь сам знак
// бренда и режет картинку под квадратную миниатюру.
const ORG_LOGO = `${SITE}/web-app-manifest-512x512.png`

module.exports = {
  SITE,
  DEFAULT_OG_IMAGE,
  OG_IMAGE_WIDTH,
  OG_IMAGE_HEIGHT,
  OG_IMAGE_ALT,
  ORG_LOGO
}
